/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: 729a07413143
 */

import * as z from "zod";
import { ApiError, ApiError$zodSchema } from "./apierror.js";
import {
  DeleteFolderResponse,
  DeleteFolderResponse$zodSchema,
} from "./deletefolderresponse.js";

export type DestroyFolderGlobals = { cloud_name?: string | undefined };

export const DestroyFolderGlobals$zodSchema: z.ZodType<DestroyFolderGlobals> = z
  .object({
    cloud_name: z.string().describe(
      "The cloud name of your product environment.",
    ).optional(),
  });

export type DestroyFolderRequest = { folder: string };

export const DestroyFolderRequest$zodSchema: z.ZodType<DestroyFolderRequest> = z
  .object({
    folder: z.string().describe(
      "The full path of the folder, including any nested folders. Must not be empty, and must not contain double slashes or leading/trailing slashes.",
    ),
  });

export type DestroyFolderResponse = DeleteFolderResponse | ApiError;

export const DestroyFolderResponse$zodSchema: z.ZodType<DestroyFolderResponse> =
  z.union([
    DeleteFolderResponse$zodSchema,
    ApiError$zodSchema,
  ]);
